import React, { Component } from 'react'
import { Row, Col } from 'antd'
import SearchField from '../../home/components/filters/SearchField'
import PropTypes from "prop-types"
import SelectFilterOptions from "../../shared/SelectFilterOptions"
import { TYPE_PARTNER_FILTER } from "../../../helpers/typePartner"

class FiltersPartner extends Component {
    _handleChangeField = (field, value) => {
        const { handleChangeFilters } = this.props

        handleChangeFilters(field, value)
    }

    render() {
        const { filters } = this.props
        const { name, type } = filters || {}

        return (
            <div className="FiltersPartner">
                <Row gutter={15}>
                    <Col span={8} className="mb-3">
                        <label className="font-weight-bold d-block">Tên đối tác</label>
                        <SearchField
                            field='name'
                            onChangeInput={this._handleChangeField}
                            placeholder='Tìm kiếm theo tên đối tác ...'
                            value={name || ''}
                        />
                    </Col>
                    <Col span={4} className="mb-3">
                        <SelectFilterOptions
                            field='type'
                            handleChange={this._handleChangeField}
                            listOptions={TYPE_PARTNER_FILTER}
                            label='Loại đối tác'
                            style={{ width: '100%' }}
                            placeholder='Chọn loại đối tác'
                            value={type || []}
                            allowClear
                        />
                    </Col>
                </Row>
            </div>
        )
    }
}

FiltersPartner.propTypes = {
    handleChangeFilters: PropTypes.func.isRequired
}

export default FiltersPartner